import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from '../shared/AnimatedSection';
import { Sign } from '../../data/signs';
interface SignPatronProps {
  sign: Sign;
}
export function SignPatron({
  sign
}: SignPatronProps) {
  return <section className="relative py-24 md:py-32 px-4 md:px-6 overflow-hidden bg-cosmic-black" data-id="element-951">
      {/* Subtle radial glow */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-952">
        <div className="absolute inset-0" style={{
        background: `radial-gradient(ellipse at center, ${sign.colors.primary}15 0%, transparent 70%)`
      }} data-id="element-953" />
      </div>

      <div className="relative z-10 container mx-auto max-w-4xl text-center" data-id="element-954">
        <AnimatedSection data-id="element-955">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-6 leading-tight" style={{
          textShadow: `0 0 30px ${sign.colors.primary}40`
        }} data-id="element-956">
            {sign.content.patronTitle}
          </h2>

          <p className="text-xl md:text-2xl font-serif italic mb-12" style={{
          color: sign.colors.accent
        }} data-id="element-957">
            {sign.content.patronSubtitle.split('\n').map((line, i) => <Fragment key={i} data-id="element-958">
                {line}
                {i === 0 && <br className="hidden sm:block" data-id="element-959" />}
              </Fragment>)}
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.15} data-id="element-960">
          <p className="text-lg md:text-xl lg:text-2xl font-serif leading-relaxed max-w-2xl mx-auto mb-16" style={{
          color: '#F5F0E1'
        }} data-id="element-961">
            {sign.content.patronText}
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.3} data-id="element-962">
          <div className="flex flex-wrap justify-center gap-3 md:gap-4" data-id="element-963">
            {sign.content.patronKeywords.map((keyword, i) => <motion.div key={keyword} className="px-4 py-2 rounded-full border text-[11px] md:text-xs tracking-[0.2em] uppercase font-serif" style={{
            borderColor: `${sign.colors.primary}40`,
            color: sign.colors.accent,
            backgroundColor: 'rgba(10,10,18,0.6)',
            boxShadow: `0 0 15px ${sign.colors.primary}10`
          }} whileHover={{
            borderColor: sign.colors.primary,
            boxShadow: `0 0 20px ${sign.colors.primary}30`,
            y: -2
          }} data-id="element-964">
                {keyword}
              </motion.div>)}
          </div>
        </AnimatedSection>
      </div>
    </section>;
}